// https://thednp.github.io/bootstrap.native/
import Boostrap from '../../../placetel/js/vendor/bootstrap-native-4.1.2/bootstrap-native-esm';

export default function() {
  document.querySelectorAll('.accordion').forEach((accordion) => {
    accordion.querySelectorAll('h5 > a').forEach((collapse) => {
      new Boostrap.Collapse(
        collapse,
        {
          parent: '#'+accordion.getAttribute('id')
        }
      );

      function swapImageOnTwoColumnsElement(collapse) {
        const accordionItem = collapse.closest('.accordion-item');
        const attachedMedia = accordionItem.querySelector('.accordion-media')?.innerHTML;
        const twoColumnsMedia = accordionItem.closest('.two-columns')?.querySelector('.section-container .images');

        if (!twoColumnsMedia || !attachedMedia) {
          return;
        }

        collapse.addEventListener('click', (ev) => {
          /**
           * the timeout prevents having the wrong state of collapsed;
           * `show.bs.collapse` gets not triggered (why?), so the click event is (mis)used here for that purpose
           */
          setTimeout(() => {
            let isCollapsed = (ev.currentTarget || ev.target)?.classList?.contains('collapsed') || false;
            if (!isCollapsed && ev.isTrusted && attachedMedia) {
              if (twoColumnsMedia.innerHTML !== attachedMedia) {
                twoColumnsMedia.innerHTML = attachedMedia;
                window.lazyLoadInstance.update();
              }
            }
          }, 10);
        }, false);
      }

      swapImageOnTwoColumnsElement(collapse);
    });



    if (accordion.querySelector('[data-show="initial"]')) {
      accordion.querySelectorAll('[data-show="initial"]').forEach(el => el.click());
    }
  });
}
